export const easeInOutSine = (x: number) => {
  return -(Math.cos(Math.PI * x) - 1) / 2;
}

export const easeOutSine = (x: number) => {
  return Math.sin((x * Math.PI) / 2);
}

export const easeInSine = (x: number) => {
  return 1 - Math.cos((x * Math.PI) / 2);
}